import React from 'react';
import { JoykitIcon } from '@components/JoykitIcon';
import {
  LanguageButton,
  ModalBody,
  ModalHeader,
  StyledButton,
  Card,
  CloseButton,
  CloseIcon,
  CardInnerContainer,
  ModalContent,
  ModalOverlay,
} from './LanguageMenu.styles';
import { useTranslation } from 'react-i18next';
import { StyledModal } from '@components/StyledModal';
import { languages } from '@i18n/i18n';

const analytics = require('/static/js/joy');

export const LanguageMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const { t, i18n } = useTranslation('languageMenu');

  const languageCode = i18n.resolvedLanguage ?? i18n.language;

  const selectableLanguages = [...languages.entries()].filter(([key]) => key !== 'en');

  return (
    <>
      <StyledModal
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        styledContent={ModalContent}
        styledOverlay={ModalOverlay}
        closeTimeoutMS={500}
      >
        <Card>
          <CloseButton id={'close'} onClick={() => setIsOpen(false)}>
            <CloseIcon name="notAttending" color="mono1" />
          </CloseButton>
          <CardInnerContainer>
            <ModalHeader>{t('title')}</ModalHeader>
            <ModalBody>
              {selectableLanguages.map(([code, name]) => (
                <LanguageButton
                  id={`${code}LanguageBtn`}
                  key={code}
                  isSelected={code === languageCode}
                  onClick={async () => {
                    analytics.segment.sendTelemetryEvent('MarcomLanguageSelected', {
                      from: languageCode,
                      to: code,
                    });

                    await i18n.changeLanguage(code);
                    setIsOpen(false);
                  }}
                >
                  {name}
                </LanguageButton>
              ))}
            </ModalBody>
          </CardInnerContainer>
        </Card>
      </StyledModal>
      <StyledButton onClick={() => setIsOpen(!isOpen)}>
        <JoykitIcon name="globe" size={16} />
        <span>{languages.get(languageCode)}</span>
      </StyledButton>
    </>
  );
};
